const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__iconfinder_4_939755",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_51",
    d: "M19.334 1H2.667A1.672 1.672 0 001 2.667v16.667A1.672 1.672 0 002.667 21h16.667A1.672 1.672 0 0021 19.334V2.667A1.672 1.672 0 0019.334 1z",
    "data-name": "Trazado 51",
    style: {
      fill: "#77777c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Brid_1_",
    d: "M22.5 14.042a7.8 7.8 0 01-1.667.542 3.55 3.55 0 001.25-1.667 8.4 8.4 0 01-1.333.75l-.333-.333a2.112 2.112 0 00-1.667-.834 2.455 2.455 0 00-2.5 2.5 1.285 1.285 0 00.042.417h-.042c-2.5 0-4.167-.542-5.417-2.083a2.625 2.625 0 00-.417 1.25 2.548 2.548 0 001.25 2.083 2.625 2.625 0 01-1.25-.417c0 1.25 1.75 2.667 2.917 2.917-.417.417-1.917.042-2.083 0a2.664 2.664 0 002.5 1.667 5.038 5.038 0 01-3.125 1.042 3.154 3.154 0 01-.625-.043 8.169 8.169 0 004.167 1.083 6.9 6.9 0 007.083-7.083v-.417a5.588 5.588 0 001.25-1.374z",
    transform: "translate(-5.25 -6.708)",
    style: {
      fill: "#f5f5f5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.08c432ea3bb25d43c5d027c259bc65a3.svg";
export { ForwardRef as ReactComponent };